import { render, staticRenderFns } from "./PackingDialog.vue?vue&type=template&id=148d8a22&scoped=true"
import script from "./PackingDialog.vue?vue&type=script&lang=js"
export * from "./PackingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d8a22",
  null
  
)

export default component.exports